import { isNullOrUndefined } from "@qntm-code/utils";

export class SolutionManager {
  // common attributes for Solution Manager properties
  id: number;
  version: number;
  name: string;
  orgId: number;
  orgName: string;
  override: boolean;
  overridable: boolean;
  inherited: boolean;

  constructor (managingOrgId?: number) {
    if (!isNullOrUndefined(managingOrgId)) { this.orgId = managingOrgId; }
    this.inherited = true;
    this.overridable = true;
  }
}
